// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useCurrentUser } from '@/authentication/hooks/use-current-user';
import { hasIntegration } from '@/utilities/integration';
import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Number of placeholder rows the skeleton draws.
 */
const SKELETON_ROW_COUNT = 10;

/**
 * Loading skeleton for the company table.
 */
export function CustomerTableSkeleton() {
  const { user } = useCurrentUser();
  const hasCrmEnabled =
    hasIntegration(user.organization.enabledIntegrations, 'HUBSPOT') ||
    hasIntegration(user.organization.enabledIntegrations, 'SFDC');

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            {hasCrmEnabled && <TableCell sx={{ width: '3rem', px: 2 }} />}
            <TableCell width="3rem" />
            <TableCell>Name</TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              Role
            </TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              Locations
            </TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              Assets on location
            </TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              Assets owned
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(SKELETON_ROW_COUNT)].map((_, index) => (
            <TableRow key={index}>
              {hasCrmEnabled && (
                <TableCell sx={{ width: '3rem', pl: 2, pr: 0 }}>
                  <Skeleton variant="circular" width={20} height={20} />
                </TableCell>
              )}
              <TableCell width="3rem">
                <Skeleton variant="circular" width={24} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                <Stack direction="row" spacing={1}>
                  <Skeleton variant="rounded" width={72} height={24} />
                  <Skeleton variant="rounded" width={68} height={24} />
                </Stack>
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                <Skeleton variant="text" width={32} />
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                <Skeleton variant="text" width={32} />
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                <Skeleton variant="text" width={32} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
